<template>
	<div class="materia-common-page">
		<div class="topbtn">
			<el-button type="primary" @click="recognize()">重新识别</el-button>
			<el-button @click="handlebatchedit">{{ editText }}</el-button>
			<el-button @click="handlebatchdelete">{{ deleteText }}</el-button>
			<el-button @click="goback()">返回</el-button>
		</div>
		<div class="group-list">
			<h3 class="head">材料信息</h3>
			<el-row :gutter="20">
				<el-col :md="8">
					<div class="grid-content">
						项目名称：{{ fileGroup.projectName }}
					</div>
				</el-col>
				<el-col :md="8">
					<div class="grid-content">
						上传时间：{{
							fileGroup.createTime
								| convertTime('YYYY-MM-DD HH:mm:ss')
						}}
					</div>
				</el-col>
				<el-col :md="8">
					<div class="grid-content">
						完成时间：
						<span v-if="fileGroup.finishTime">{{
							fileGroup.finishTime
								| convertTime('YYYY-MM-DD HH:mm:ss')
						}}</span>
					</div>
				</el-col>
				<el-col :md="8">
					<div class="grid-content">
						患者来源：{{ getSource(fileGroup.patientSource) }}
					</div>
				</el-col>
				<el-col :md="8">
					<div class="grid-content">
						状态：
						<el-tag
							v-if="getStatus(fileGroup.status) == '已完成'"
							effect="dark"
							type="success"
							>已完成</el-tag
						>
						<el-tag v-else effect="dark" type="danger">{{
							getStatus(fileGroup.status)
						}}</el-tag>
					</div>
				</el-col>
				<el-col v-if="fileGroup.reason" :md="8">
					<div class="grid-content">备注：{{ fileGroup.reason }}</div>
				</el-col>
			</el-row>
		</div>
		<div class="group-list">
			<h3 class="head">患者信息</h3>

			<el-form
				ref="patientInfoForm"
				:inline="true"
				:model="formInline"
				class="demo-form-inline"
				:rules="rules"
			>
				<el-form-item label="援助方式：" prop="patientName">{{
					fileGroup.patientMode
				}}</el-form-item>
				<el-form-item label="患者姓名：" prop="patientName">
					<el-input v-model="formInline.patientName" />
				</el-form-item>
				<el-form-item label="身份证号：" prop="idcard">
					<el-input v-model="formInline.idcard" />
					<!-- :disabled="fileGroup.idcard!=null" -->
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="searchPatinetList"
						>查询患者</el-button
					>
					<el-button type="primary" @click="submitrecordPatient"
						>录入患者</el-button
					>
				</el-form-item>
			</el-form>
		</div>
		<div class="group-list">
			<h3 class="head">材料条目</h3>
			<el-row :gutter="30">
				<el-col :span="24">
					<div class="grid-content">
						按领药阶段次数：
						<el-tag
							:type="clickPhase == '全部' ? '' : 'info'"
							class="tag-list-box1"
							@click="handlePhase('全部')"
							>全部({{ AllphaseNum }})</el-tag
						>
						<el-tag
							v-for="(child, index) in files"
							:key="index"
							class="tag-list-box"
							:type="
								clickPhase.phase == child.phase &&
								clickPhase.times == child.times
									? ''
									: 'info'
							"
							@click="handlePhase(child)"
							>{{
								child.phase * 1
									? '第' +
									  child.phase +
									  '阶段' +
									  '第' +
									  child.times +
									  '次领药'
									: '无阶段'
							}}({{ child.fileNum }})</el-tag
						>
					</div>
				</el-col>
				<el-col :span="24">
					<div class="grid-content">
						按材料类别：
						<el-tag
							:type="clickCheck == '全部' ? '' : 'info'"
							class="tag-list-box1"
							@click="handleCheck('全部')"
							>全部({{ AllphaseNum }})</el-tag
						>
						<el-tag
							v-for="(child, index) in allCheck"
							:key="index"
							class="tag-list-box"
							:type="clickCheck == child.item ? '' : 'info'"
							@click="handleCheck(child.item)"
							>{{ child.item }}({{ child.fileNum }})</el-tag
						>
					</div>
				</el-col>

				<el-col
					v-for="(ele, index) in perfilesImage[
						listQuery.pageIndex - 1
					]"
					:key="index"
					:md="6"
					class="file-list"
				>
					<div class="grid-img-box">
						<el-image
							:src="ele.url"
							fit="cover"
							style="height:270px;"
							:preview-src-list="srcList"
							@click="openImage(ele.url)"
						/>

						<p class="clearfix">
							<span class="fl">{{ ele.linkSource }}</span>
							<span class="fr">
								<i
									class="el-icon-search"
									@click="handleWatchInfo(ele.id)"
								/>
								<i
									v-if="!batchdelete"
									class="el-icon-edit"
									@click="handleEditCheckItem(ele.id, ele)"
								/>
								<i
									v-if="!batchedit"
									class="el-icon-delete"
									@click="handleDeteleFile(ele.id, ele)"
								/>
							</span>
						</p>
						<p>
							<el-checkbox
								v-if="batchedit || batchdelete"
								v-model="ele.checked"
								>{{
									ele.phase * 1
										? '第' +
										  ele.phase +
										  '阶段' +
										  '第' +
										  ele.times +
										  '次领药'
										: '无阶段'
								}}-{{ ele.item }}</el-checkbox
							>
							<span v-if="!batchedit && !batchdelete"
								>{{
									ele.phase * 1
										? '第' +
										  ele.phase +
										  '阶段' +
										  '第' +
										  ele.times +
										  '次领药'
										: '无阶段'
								}}-{{ ele.item }}</span
							>
						</p>
						<p>{{ ele.fileName }}</p>
					</div>
				</el-col>
			</el-row>
			<pagination
				v-show="total > 0"
				:total="total"
				:page.sync="listQuery.pageIndex"
				:limit.sync="listQuery.pageSize"
				@pagination="getList"
			/>
		</div>

		<!-- 患者查询 -->
		<el-dialog
			title="患者查询"
			:visible.sync="outerVisible"
			class="patient-seach-dialog"
		>
			<el-dialog
				title="患者详情"
				:visible.sync="innerVisible"
				append-to-body
				style="min-width:600px;"
				class="patient-inner-dialog"
			>
				<el-tabs v-model="activeName" type="card">
					<el-tab-pane
						label="系统信息"
						name="first"
						class="tab-patient"
					>
						<el-row>
							<el-col :span="12">
								<div class="grid-patient-list">
									<p>
										<span>录入时间</span>
										<span>{{
											patientAllDetail.created
												| convertTime(
													'YYYY-MM-DD HH:mm:ss'
												)
										}}</span>
									</p>
									<p>
										<span>申请时间</span>
										<span>{{
											patientAllDetail.submit_dateline
												| convertTime(
													'YYYY-MM-DD HH:mm:ss'
												)
										}}</span>
									</p>
									<p>
										<span>最后更新时间</span>
										<span>{{
											patientAllDetail.updated
												| convertTime(
													'YYYY-MM-DD HH:mm:ss'
												)
										}}</span>
									</p>
									<p>
										<span>综合审核时间</span>
										<span>{{
											patientAllDetail.check_dateline
												| convertTime(
													'YYYY-MM-DD HH:mm:ss'
												)
										}}</span>
									</p>
									<p>
										<span>出组人</span>
										<span>{{
											patientAllDetail.out_username
										}}</span>
									</p>
									<p>
										<span>归档人</span>
										<span>{{
											patientAllDetail.archive_username
										}}</span>
									</p>
									<p>
										<span>是否临时冻结</span>
										<span>{{
											patientAllDetail.tmp_freezed
												? '是'
												: '否'
										}}</span>
									</p>
									<p>
										<span>流程状态</span>
										<span>{{
											patientAllDetail.status
										}}</span>
									</p>
									<p>
										<span>总领药次数</span>
										<span>{{
											patientAllDetail.total_received_times
										}}</span>
									</p>
									<p>
										<span>领药阶段</span>
										<span>{{
											patientAllDetail.receive_phase
										}}</span>
									</p>
									<p>
										<span>暂停原因</span>
										<span>{{
											patientAllDetail.pause_reason
										}}</span>
									</p>
									<p>
										<span>辅助管理员姓名</span>
										<span>{{
											patientAllDetail.em_name
										}}</span>
									</p>
									<p>
										<span>辅助管理员手机号</span>
										<span>{{
											patientAllDetail.em_mobile
										}}</span>
									</p>
								</div>
							</el-col>
							<el-col :span="12">
								<div class="grid-patient-list">
									<p>
										<span>申请来源</span>
										<span>{{
											patientAllDetail.source
										}}</span>
									</p>
									<p>
										<span>录入人</span>
										<span>{{
											patientAllDetail.submit_username
										}}</span>
									</p>
									<p>
										<span>综合审核人</span>
										<span>{{
											patientAllDetail.check_username
										}}</span>
									</p>
									<p>
										<span>入组日期</span>
										<span>{{
											patientAllDetail.in_date
												| convertTime('YYYY-MM-DD')
										}}</span>
									</p>
									<p>
										<span>出组日期</span>
										<span>{{
											patientAllDetail.out_date
												| convertTime('YYYY-MM-DD')
										}}</span>
									</p>
									<p>
										<span>归档时间</span>
										<span>{{
											patientAllDetail.archive_dateline
												| convertTime('YYYY-MM-DD')
										}}</span>
									</p>
									<p>
										<span>变方式重入组</span>
										<span>{{
											patientAllDetail.is_referral
												? '是'
												: '否'
										}}</span>
									</p>
									<p>
										<span>阶段已领药次数</span>
										<span>{{
											patientAllDetail.received_times
										}}</span>
									</p>
									<p>
										<span>轮次</span>
										<span>{{
											patientAllDetail.rounds
										}}</span>
									</p>
									<p>
										<span>本轮起始时间</span>
										<span>{{
											patientAllDetail.round_start_time
										}}</span>
									</p>
									<p>
										<span>出组原因</span>
										<span>{{
											patientAllDetail.out_reason
										}}</span>
									</p>
									<p>
										<span>辅助申请来源</span>
										<span>{{
											patientAllDetail.apply_type
										}}</span>
									</p>
									<p />
								</div>
							</el-col>
						</el-row>
					</el-tab-pane>
					<el-tab-pane
						label="基本信息"
						name="second"
						class="tab-patient"
					>
						<el-row>
							<el-col :span="12">
								<div class="grid-patient-list">
									<p>
										<span>患者ID</span>
										<span>{{ patientAllDetail.id }}</span>
									</p>
									<p>
										<span>姓名</span>
										<span>{{ patientAllDetail.name }}</span>
									</p>
									<p>
										<span>年龄</span>
										<span>{{
											getAge(patientAllDetail.birthdate)
										}}</span>
									</p>
									<p>
										<span>证件类型</span>
										<span>{{
											patientAllDetail.id_type
										}}</span>
									</p>
									<p>
										<span>手机号</span>
										<span>{{
											patientAllDetail.mobile
										}}</span>
									</p>
									<p>
										<span>项目所在省</span>
										<span>{{
											patientAllDetail.province
										}}</span>
									</p>
									<p>
										<span>医院名称</span>
										<span>{{
											patientAllDetail.hospital_name
										}}</span>
									</p>
									<!-- <p>
                    <span>医院配送日</span>

                    <span></span>
                  </p>-->
									<p>
										<span>援助方式名称</span>
										<span>{{
											patientAllDetail.mode_name
										}}</span>
									</p>
									<p>
										<span>入组备注</span>
										<span>{{
											patientAllDetail.remark
										}}</span>
									</p>
									<p>
										<span>户口性质</span>
										<span>{{
											patientAllDetail.hukou_type
										}}</span>
									</p>
									<p>
										<span>医保性质</span>
										<span>{{
											patientAllDetail.yibao_type
										}}</span>
									</p>
									<p>
										<span>公益专员姓名</span>

										<span>{{
											patientAllDetail.volunteer_name
										}}</span>
									</p>
									<p>
										<span>患者身份</span>
										<span>{{
											patientAllDetail.identity
										}}</span>
									</p>
									<!-- <p>
                    <span>注射医院</span>

                    <span></span>
                  </p>-->
									<!-- <p>
                    <span>第一联系人电话</span>

                    <span></span>
                  </p>-->
									<!-- <p>
                    <span>自购药数量</span>

                    <span></span>
                  </p>-->
									<!-- <p>
                    <span>预约申请医院</span>

                    <span></span>
                  </p>-->
									<!-- <p>
                    <span>预约申请药房</span>

                    <span></span>
                  </p>-->
								</div>
							</el-col>
							<el-col :span="12">
								<div class="grid-patient-list">
									<p>
										<span>患者编号</span>
										<span>{{ patientAllDetail.sn }}</span>
									</p>
									<p>
										<span>出生年月日</span>
										<span>{{
											patientAllDetail.birthdate
												| convertTime('YYYY-MM-DD ')
										}}</span>
									</p>
									<p>
										<span>性别</span>
										<span>{{
											patientAllDetail.gender
										}}</span>
									</p>
									<p>
										<span>证件号码</span>
										<span>{{ patientAllDetail.idsn }}</span>
									</p>
									<p>
										<span>所在大区</span>
										<span>{{ patientAllDetail.area }}</span>
									</p>
									<p>
										<span>项目所在市</span>
										<span>{{ patientAllDetail.city }}</span>
									</p>
									<p>
										<span>项目医生</span>
										<span>{{
											patientAllDetail.doctor_name
										}}</span>
									</p>
									<p>
										<span>药房名称</span>
										<el-tooltip
											class="item"
											effect="dark"
											:content="
												patientAllDetail.drugstore_name
											"
											placement="top-start"
										>
											<span>{{
												patientAllDetail.drugstore_name
											}}</span>
										</el-tooltip>
									</p>
									<p>
										<span>援助子项目名称</span>

										<span>{{
											patientAllDetail.project_name
										}}</span>
									</p>
									<p>
										<span>户口所在地</span>
										<span
											>{{
												patientAllDetail.residence_province
											}}-{{
												patientAllDetail.residence_city
											}}-{{
												patientAllDetail.residence_district
											}}</span
										>
									</p>
									<p>
										<span>医保所在地</span>
										<span
											v-if="
												patientAllDetail.medicare_province &&
													patientAllDetail.medicare_city
											"
											>{{
												patientAllDetail.medicare_province
											}}-{{
												patientAllDetail.medicare_city
											}}-{{
												patientAllDetail.medicare_district
											}}</span
										>
									</p>
									<p>
										<span>是否享受医保</span>
										<span>{{
											patientAllDetail.yibao_joined
												? '是'
												: '否'
										}}</span>
									</p>
									<p />
									<!-- <p>
                    <span>第一联系人姓名</span>

                    <span></span>
                  </p>-->
									<!-- <p>
                    <span>末次用药日期</span>

                    <span></span>
                  </p>-->
									<!-- <p>
                    <span>是否自购过药品</span>

                    <span></span>
                  </p>-->
									<!-- <p>
                    <span>预约申请医生</span>

                    <span></span>
                  </p>-->
									<!-- <p>
                    <span>疾病类型</span>

                    <span></span>
                  </p>-->
								</div>
							</el-col>
						</el-row>
					</el-tab-pane>
				</el-tabs>
				<div slot="footer" class="dialog-footer">
					<el-button @click="innerVisible = false">返回</el-button>
					<el-button type="primary" @click="choseThisPatient"
						>选择本患者</el-button
					>
				</div>
			</el-dialog>
			<el-form
				:inline="true"
				class="demo-form-inline"
				label-width="100px"
			>
				<el-form-item label="患者姓名">
					<el-input v-model="patientItemForm.patientName" />
				</el-form-item>
				<el-form-item label="手机号">
					<el-input v-model="patientItemForm.mobile" />
				</el-form-item>
				<el-form-item label="医院名称">
					<el-input v-model="patientItemForm.hospitalName" />
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="SearchPatinetconditions"
						>查询</el-button
					>
					<el-button type="primary" @click="reset">重置</el-button>
				</el-form-item>
			</el-form>
			<el-table
				ref="multipleTable"
				:data="patientData"
				highlight-current-row
				style="width: 100%"
				@current-change="handleSelectionChange"
			>
				<el-table-column type="index" width="55" />
				<el-table-column label="ID" prop="id" />
				<el-table-column prop="sn" label="患者编号" width="120" />
				<el-table-column prop="name" label="姓名" width="120" />

				<el-table-column prop="address" label="年龄">
					<template slot-scope="scope">
						<p>{{ getAge(scope.row.birthdate) }}</p>
					</template>
				</el-table-column>
				<el-table-column prop="gender" label="性别" />
				<el-table-column
					prop="city"
					label="城市"
					show-overflow-tooltip
				/>
				<el-table-column
					prop="hospital_name"
					label="医院名称"
					show-overflow-tooltip
				/>

				<el-table-column prop="status" label="流程状态" />

				<el-table-column prop="address" label="总次数/阶段" width="120">
					<template slot-scope="scope">
						<p
							v-if="
								scope.row.total_received_times &&
									scope.row.receive_phase
							"
						>
							{{ scope.row.total_received_times }}/{{
								scope.row.receive_phase
							}}
						</p>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="120" fixed="right">
					<template slot-scope="scope">
						<el-button
							type="text"
							size="small"
							@click="handlePatientDetail(scope.row)"
							>查看</el-button
						>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination
				background
				:page-size="10"
				layout="prev, pager, next"
				:total="patientTotal"
				:current-page.sync="currentPage1"
				@current-change="handleCurrentChange"
			/>
			<div slot="footer" class="dialog-footer">
				<el-button @click="outerVisible = false">取 消</el-button>
				<el-button type="primary" @click="choseThisPatient"
					>选择本患者</el-button
				>
			</div>
		</el-dialog>

		<!-- 档案信息查看 -->
		<el-dialog
			title="档案信息查看"
			:visible.sync="dialogTableVisible"
			class="patient-seach-dialog"
		>
			<p v-if="tabelInfo.length">材料编号：{{ tabelInfo[0].objId }}</p>
			<el-table :data="tabelInfo">
				<el-table-column label="操作">
					<template slot-scope="scope">
						<p>{{ getType(scope.row.type) }}</p>
					</template>
				</el-table-column>
				<el-table-column property="oldValue" label="编辑前" />
				<el-table-column property="currentValue" label="编辑后" />
				<el-table-column property="accountName" label="编辑人" />
				<el-table-column label="编辑时间" width="160">
					<template slot-scope="scope">
						<p v-if="scope.row.updateTime">
							{{
								scope.row.updateTime
									| convertTime('YYYY-MM-DD HH:mm:ss')
							}}
						</p>
					</template>
				</el-table-column>
			</el-table>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogTableVisible = false">关闭</el-button>
			</div>
		</el-dialog>
		<el-dialog title="档案信息编辑" :visible.sync="dialogFormVisible">
			<el-form>
				<el-form-item v-if="batchedit" label="材料类型">
					<el-select
						v-if="batchedit"
						v-model="checkitemForm.groupType"
						@change="groupTypechange"
					>
						<el-option
							v-for="(item, index) in materialType"
							:key="index"
							:label="item.label"
							:value="item.value"
						/>
					</el-select>
					<p style="margin-bottom:0px;">
						修改分组后，非患者本人及患者本人其它类型材料将移入新组
					</p>
					<p style="margin-top:0px;">请确保同类材料一并提交</p>
				</el-form-item>

				<el-form-item label="领药阶段">
					<el-select
						v-model="checkitemForm.phase"
						:disabled="
							this.checkitemForm.groupType &&
								this.checkitemForm.groupType != 12 &&
								batchedit
						"
					>
						<el-option label="无阶段" :value="0" />
						<el-option
							v-for="item in checkItemPhase"
							:key="item"
							:label="'第' + item + '阶段'"
							:value="item"
						/>
					</el-select>
				</el-form-item>
				<el-form-item label="领药次数">
					<el-select
						v-model="checkitemForm.times"
						:disabled="
							this.checkitemForm.groupType &&
								this.checkitemForm.groupType != 12 &&
								batchedit
						"
					>
						<el-option label="无次数" :value="0" />
						<el-option
							v-for="item in checkItemList"
							:key="item"
							:label="'第' + item + '次领药'"
							:value="item"
						/>
					</el-select>
				</el-form-item>
				<el-form-item label="材料类别">
					<el-select
						v-model="checkitemForm.item"
						:disabled="
							this.checkitemForm.groupType &&
								this.checkitemForm.groupType != 12 &&
								batchedit
						"
					>
						<el-option
							v-for="item in checkItemSelect"
							:key="item.item"
							:label="item.item"
							:value="item.item"
						/>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="FileInfoEdit">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import {
	groudetail,
	patientquery,
	filedel,
	checkItemquery,
	filedetail,
	fileupdate,
	queryDetail,
	updateByManual,
	updateByPap
} from '@/api/manage'
import { all } from 'q'
import { reLink } from '@/api/manage'
import { groupreceiveitems } from '@/api/Materialkey'
import Pagination from '@/components/Pagination'
export default {
	inject: ['reload'],
	components: { Pagination },
	data() {
		var validateIdenty = (rule, value, callback) => {
			if (!value) {
				console.log('value', value)
				callback(new Error('请填写身份证号'))
			} else {
				console.log('value', value)
				const bool = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/.test(
					value
				)

				if (!bool) {
					console.log('value', value)
					callback(new Error('请输入正确的身份证号'))
				} else {
					callback()
				}
			}
		}
		return {
			total: 0, // 总个数
			listQuery: {
				pageIndex: 1,
				pageSize: 10
			},
			perfilesImage: [], // 每页的图片数组
			id: null,
			projectId: null,
			fileGroup: {},
			files: [],
			checkItemSelect: [],
			allCheck: [], // 所有条目
			filesImage: [], // 放下面的文件图片用于筛选
			url:
				'http://file.amp.sungotech.com/store/yrk_dev2/IMG_2019-07-26-16-30-01.jpg',
			srcList: [], // 放下面的文件图片用于筛选
			AllphaseNum: 0, // 全部阶段数目
			AllcheckNum: 0, // 全部条目数目
			clickPhase: '全部', // 点击的阶段
			clickCheck: '全部', // 点击的条目
			formInline: {},
			outerVisible: false,
			innerVisible: false,
			patientData: [],
			patientAllDetail: {}, // 患者基本和系统信息
			activeName: 'first',
			dialogTableVisible: false,
			dialogFormVisible: false,
			checkItemList: null, // 审核条目列表
			checkitemForm: {
				item: null,
				times: null,
				phase: null,
				groupType: null
			},
			patientItemForm: {
				patientName: null,
				mobile: null,
				hospitalName: null
			},
			tabelInfo: [], // 档案信息
			patientTotal: 0, // 患者个数
			currentPage1: 1,
			formInline: {
				patientName: '',
				idcard: ''
			},
			rules: {
				patientName: {
					required: true,
					message: '请填写患者姓名',
					trigger: 'blur'
				},
				idcard: [
					{
						required: true,
						validator: validateIdenty,
						trigger: 'blur'
					}
				]
			},
			currentRow: null,
			editText: '批量修改',
			deleteText: '批量删除',
			batchedit: false,
			batchdelete: false,
			checkItemPhase: null,
			materialType: [
				{ label: '本患者审核材料', value: 11 },
				{ label: '本患者物流材料', value: 12 },
				{ label: '其他患者审核材料', value: 21 },
				{ label: '其他患者物流材料', value: 22 }
			]
		}
	},
	computed: {
		patientstatus() {
			switch (this.fileGroup.status) {
				case 50:
					return '失败'
					break
				case 0:
					return '初始化'
					break
				case 20:
					return '匹配中'
					break
				case 30:
					return '已完成'
					break
			}
		}
	},
	created() {
		this.id = this.$route.params.id * 1
		this.projectId = this.$route.params.projectId * 1
		// 获取项目
		// checkItemquery(this.id).then(res => {
		//   this.checkItemList = res.data;
		// });
		//
		groupreceiveitems(this.id).then(res => {
			if (res.data) {
				this.checkItemList = res.data.receivedTimes
				this.checkItemPhase = res.data.maxPhase

				this.checkItemSelect = res.data.items
			}
		})
		this.initData()
	},
	methods: {
		handlebatchedit() {
			this.batchedit = !this.batchedit
			if (this.batchedit) {
				this.editText = '取消操作'
				this.batchdelete = false
				this.deleteText = '批量删除'
			} else {
				this.editText = '批量编辑'
			}
		},
		handlebatchdelete() {
			this.batchdelete = !this.batchdelete
			if (this.batchdelete) {
				this.deleteText = '取消操作'
				this.batchedit = false
				this.editText = '批量编辑'
			} else {
				this.deleteText = '批量删除'
			}
		},
		// 切割数组
		chunk(arr, size) {
			var objArr = new Array()
			var index = 0
			var objArrLen = arr.length / size
			for (var i = 0; i < objArrLen; i++) {
				var arrTemp = new Array()
				for (var j = 0; j < size; j++) {
					arrTemp[j] = arr[index++]
					if (index == arr.length) {
						break
					}
				}
				objArr[i] = arrTemp
			}
			console.log('objArr', objArr)
			return objArr
		},
		getList() {
			this.total = this.filesImage.length
			this.perfilesImage = this.chunk(
				this.filesImage,
				this.listQuery.pageSize
			)
		},
		goback() {
			this.$router.go(-1)
		},
		goback11() {
			for (let index = 48; index < 50; index++) {
				checkItemquery(index).then(res => {
					reLink(index).then(info => {})
				})
			}
		},
		recognize() {
			reLink(this.id)
				.then(res => {
					this.$message({
						message: res.message,
						type: 'success'
					})
				})
				.catch(err => {
					console.log('err', err)
					this.$message.error(err.message)
				})
		},
		openImage(url) {
			this.srcList = []
			this.srcList.push(url)
		},
		// 获取 操作类型
		getType(data) {
			switch (data) {
				case 10:
					return '上传文件'
					break
				case 20:
					return '编辑材料'
					break
				case 30:
					return '删除材料'
					break
				case 40:
					return '指定患者'
					break
				case 50:
					return '上传文件组'
					break
			}
		},
		// 患者来源
		getSource(data) {
			switch (data) {
				case 0:
					return '无'
					break
				case 10:
					return '系统识别'
					break
				case 20:
					return '手动指定'
					break
				case 30:
					return '新患者'
					break
			}
		},
		// 状态
		getStatus(data) {
			switch (data) {
				case -70:
					return '待指定新患者'
					break
				case -60:
					return '识别多张身份证'
					break
				case 21:
					return '未分配援助方式'
					break
				case -50:
					return '未识别患者信息'
					break
				case -100:
					return '错误'
					break
				case 0:
					return '初始化'
					break
				case -40:
					return '重复患者'
					break
				case 20:
					return '匹配中'
					break
				case 30:
					return '已完成'
					break
			}
		},
		initData() {
			groudetail(this.id).then(res => {
				this.fileGroup = res.data.fileGroup
				this.formInline = {
					patientName: this.fileGroup.patientName,
					idcard: this.fileGroup.idcard
				}
				if (!res.data.files.length) {
					this.$alert('当前记录无材料', '无数据', {
						confirmButtonText: '退出',
						callback: () => {
							this.$store.dispatch(
								'tagsView/delView',
								this.$route
							)
							this.$router.go(-1)
						}
					})
					return
				}
				this.files = res.data.files
				this.filesImage = []
				this.allCheck = []
				this.AllphaseNum = 0
				var entry = []
				// 得到所有的文件列表
				this.files.forEach(item => {
					this.AllphaseNum += item.fileNum
					if (item['items'] && item['items'].length) {
						item['items'].forEach(ele => {
							entry.push(ele)
							ele.subFiles.forEach(con => {
								this.filesImage.push(con)
							})
						})
					}
				})
				// 展示的文件列表
				this.filesImage.sort((a, b) => {
					return b['createTime'] - a['createTime']
				})
				this.filesImage.forEach(item => {
					this.$set(item, 'checked', false)
				})
				this.total = this.filesImage.length
				this.perfilesImage = this.chunk(
					this.filesImage,
					this.listQuery.pageSize
				)
				// for (var i = 0; i < this.filesImage.length; i++) {
				//   this.filesImage[i].checked = false;
				// }
				// 去重条目并相加个数
				this.allCheck = []
				console.log('entry', entry)
				for (const i of entry) {
					var a = this.allCheck.find(
						item => item['item'] == i['item']
					)
					if (!a) {
						this.allCheck.push(i)
					} else {
						this.allCheck.forEach(ele => {
							if (ele['item'] == i['item']) {
								ele.fileNum += i['fileNum']
							}
						})
					}
				}
			})
		},
		// 录入患者信息
		submitrecordPatient() {
			this.$refs['patientInfoForm'].validate(valid => {
				if (valid) {
					const info = {
						idcard: this.formInline.idcard.trim(),
						patientName: this.formInline.patientName.trim(),
						id: this.id
					}
					this.$confirm('是否确认修改患者身份信息？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
						.then(() => {
							updateByManual(info)
								.then(res => {
									this.$message({
										message: '录入成功',
										type: 'success'
									})
									this.fileGroup.patientName = this.formInline.idcard.trim()
									this.fileGroup.idcard = this.formInline.patientName.trim()
								})
								.catch(err => {
									if(err.message.match('查询无该患者')){
										this.$alert('身份证信息不存在于患者信息库中', '查询无该患者', {
											confirmButtonText: '确定'
											})
										return
									}
									this.$message.error(err.message)
								})
						})
						.catch(() => {})
				} else {
					return false
				}
			})
		},
		// 分页查询患者
		searchPatinetList() {
			this.currentPage1 = 1
			this.patientSearch = {
				projectId: this.projectId, // 项目ID
				patientName: null,
				mobile: null,
				hospitalName: null,
				pageIndex: 1,
				pageSize: 10
			}
			patientquery(this.patientSearch).then(res => {
				this.patientData = res.data.records
				this.outerVisible = true
				this.patientTotal = res.data.size
			})
		},
		// 点击分页查询患者
		handleCurrentChange(val) {
			this.patientSearch.pageIndex = val
			patientquery(this.patientSearch).then(res => {
				this.patientData = res.data.records
				this.patientTotal = res.data.size
			})
		},
		// 重置
		reset() {
			this.patientItemForm = {
				patientName: null,
				mobile: null,
				hospitalName: null
			}
			this.searchPatinetList()
		},
		// 查询患者
		SearchPatinetconditions() {
			this.patientSearch.patientName = this.patientItemForm.patientName
				? this.patientItemForm.patientName.trim()
				: null
			this.patientSearch.mobile = this.patientItemForm.mobile
				? this.patientItemForm.mobile.trim()
				: null
			this.patientSearch.hospitalName = this.patientItemForm.hospitalName
				? this.patientItemForm.hospitalName.trim()
				: null
			patientquery(this.patientSearch).then(res => {
				this.patientData = res.data.records
				this.patientTotal = res.data.size
				this.currentPage1 = 1
			})
		},
		// 查看患者具体
		handlePatientDetail(row) {
			console.log('row', row)
			const info = {
				projectId: row.project_id,
				id: row.id
			}
			queryDetail(info).then(res => {
				this.patientAllDetail = res.data
				this.innerVisible = true
			})
		},
		// 删除文件
		handleDeteleFile(info, index) {
			if (this.batchdelete) {
				var arr1 = this.filesImage.filter(item => {
					return item.checked == true
				})
				var isThisone = arr1.find(aa => aa.id == index.id)
				if (!isThisone) {
					this.$message({
						message: '请选择材料后操作',
						type: 'warning'
					})
					return false
				}
				if (arr1.length) {
					this.$confirm('此操作将删除该文件, 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
						.then(() => {
							var list1 = []
							arr1.forEach(ele => {
								list1.push(ele.id)
							})
							var ee = {
								fileIds: list1.join(',')
							}
							filedel(ee).then(res => {
								this.reload()
								this.$message({
									message: res.message,
									type: 'success'
								})
							})
						})
						.catch(() => {})
				} else {
					this.$message({
						message: '请选择材料后操作',
						type: 'warning'
					})
					return false
				}
			} else {
				this.$confirm('此操作将删除该文件, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var dd = {
						fileId: info
					}
					filedel(dd).then(res => {
						this.reload()
						this.$message({
							message: res.message,
							type: 'success'
						})
					})
				})
			}
		},
		// 点击条目小按钮
		handleCheck(info) {
			this.clickCheck = info
			this.beginscreening()
		},
		// 点击阶段小按钮
		handlePhase(info) {
			this.clickPhase = info
			this.beginscreening()
		},
		// 筛选当前的文件
		beginscreening() {
			this.filesImage = []
			if (this.clickPhase == '全部') {
				if (this.clickCheck == '全部') {
					this.files.forEach(item => {
						if (item['items'] && item['items'].length) {
							item['items'].forEach(ele => {
								ele.subFiles.forEach(con => {
									this.filesImage.push(con)
								})
							})
						}
					})
				} else {
					this.files.forEach(item => {
						item.items.forEach(name => {
							if (name.item == this.clickCheck) {
								this.filesImage.push(...name.subFiles)
							}
						})
					})
				}
			} else {
				var nowPase = []
				this.files.forEach(item => {
					if (
						item.phase == this.clickPhase.phase &&
						item.times == this.clickPhase.times
					) {
						nowPase.push(item)
					}
				})
				if (this.clickCheck == '全部') {
					nowPase.forEach(item => {
						if (item['items'] && item['items'].length) {
							item['items'].forEach(ele => {
								ele.subFiles.forEach(con => {
									this.filesImage.push(con)
								})
							})
						}
					})
				} else {
					nowPase[0].items.forEach(item => {
						if (item.item == this.clickCheck) {
							this.filesImage.push(...item.subFiles)
						}
					})
				}
			}
			this.total = this.filesImage.length
			this.listQuery = {
				pageIndex: 1,
				pageSize: 10
			}
			this.perfilesImage = this.chunk(
				this.filesImage,
				this.listQuery.pageSize
			)
		},
		// 点击编辑小按钮
		handleEditCheckItem(id, el) {
			this.checkitemForm.groupType = null
			if (this.batchedit) {
				var arr = this.filesImage.filter(item => {
					return item.checked == true
				})
				if (arr.length) {
					var isThisone = arr.find(aa => aa.id == el.id)
					if (!isThisone) {
						this.$message({
							message: '请选择材料后操作',
							type: 'warning'
						})
						return false
					}
					if (arr.length == 1) {
						if (
							this.fileGroup.patientName &&
							this.fileGroup.idcard
						) {
							this.handleCheckId = id
							this.checkitemForm.phase = el.phase * 1
							this.checkitemForm.times = el.times * 1
							this.checkitemForm.item = el.item
							this.dialogFormVisible = true
						} else {
							this.$message({
								message: '请填写患者信息再编辑',
								type: 'warning'
							})
							return false
						}
					} else {
						this.checkitemForm.phase = null
						this.checkitemForm.item = null
						this.checkitemForm.times = null
						var list = []
						arr.forEach(ele => {
							list.push(ele.id)
						})
						this.handleCheckId = list.join(',')

						this.dialogFormVisible = true
					}
				} else {
					this.$message({
						message: '请选择材料后操作',
						type: 'warning'
					})
					return false
				}
			} else {
				if (this.fileGroup.patientName && this.fileGroup.idcard) {
					this.handleCheckId = id
					console.log('el', el)
					this.checkitemForm.phase = el.phase * 1
					this.checkitemForm.times = el.times * 1
					this.checkitemForm.item = el.item
					this.checkitemForm.groupType = el.groupType
					this.dialogFormVisible = true
				} else {
					this.$message({
						message: '请填写患者信息再编辑',
						type: 'warning'
					})
					return false
				}
			}
		},
		// 确定编辑档案信息
		FileInfoEdit() {
			const info = {
				fileIds: this.handleCheckId,
				phase: this.checkitemForm.phase * 1,
				times: this.checkitemForm.times * 1,
				item:
					this.checkitemForm.phase * 1
						? this.checkitemForm.item
						: '其他',
				projectId: this.projectId,
				groupType: this.checkitemForm.groupType
			}
			fileupdate(info).then(res => {
				this.filesImage.forEach((item, index) => {
					if (item.id == this.handleCheckId) {
						this.filesImage[index] = res.data
					}
				})

				console.log('this.filesImage', this.filesImage)
				this.$message({
					message: '修改成功',
					type: 'success'
				})
				this.reload()
			})
		},
		// 点击查看档案信息小按钮
		handleWatchInfo(id) {
			filedetail(id).then(res => {
				this.tabelInfo = res.data
				this.dialogTableVisible = true
			})
		},
		// 年龄
		getAge(data) {
			var info = new Date().getTime() - data
			return parseInt(info / 1000 / 365 / 60 / 60 / 24)
		},
		handleSelectionChange(val) {
			this.currentRow = val
		},

		// 点击pap指定患者
		choseThisPatient() {
			if (!this.currentRow) {
				this.$message.error('请选择患者')
				return false
			}
			const info = {
				patientId: this.currentRow.id,
				id: this.id
			}

			this.$confirm('是否确认修改患者身份信息？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					updateByPap(info)
						.then(res => {
							this.$message({
								message: '录入成功',
								type: 'success'
							})
							this.fileGroup.patientName = res.data.patientName
							this.fileGroup.idcard = res.data.idcard
							this.outerVisible = false
							this.innerVisible = false
						})
						.catch(err => {
							this.$message.error(err.message)
						})
				})
				.catch(() => {})
		},
		groupTypechange() {
			if (this.checkitemForm.groupType) {
				if (this.checkitemForm.groupType == 11) {
				} else {
					this.checkitemForm.phase = 0
					this.checkitemForm.times = 0
					this.checkitemForm.item = '其他'
				}
			}
		}
	}
}
</script>
<style lang="scss" scoped>
.materia-common-page {
	padding: 0 30px;
	.group-list {
		margin-bottom: 40px;
		.file-list {
			min-width: 320px;
		}
		.grid-content {
			line-height: 38px;
		}
		.grid-img-box {
			margin-top: 20px;
			line-height: 28px;
			p {
				width: 100%;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				margin: 0px;
				i {
					margin-right: 6px;
				}
			}
		}
	}
}
</style>

<style lang="scss">
.materia-common-page {
	.topbtn {
		display: flex;
		justify-content: flex-end;
	}
	.el-dialog {
		min-width: 300px;
	}
	.patient-seach-dialog {
		.el-dialog__body {
			height: 500px;
			overflow: auto;
		}
	}

	.tag-list-box {
		margin-right: 10px;
	}
	.tag-list-box1 {
		margin-right: 6px;
	}
}
.patient-inner-dialog {
	.el-dialog {
		width: 670px;
	}
	.el-tabs__content {
		height: 500px;
		overflow: auto;
	}
	.tab-patient {
		.grid-patient-list {
			p {
				height: 38.39px;
				border-top: 1px solid #ccc;
				margin: 0px;
				padding: 10px 0;
				&:nth-child(2n) {
					background-color: #fff;
				}
				&:nth-child(2n + 1) {
					background-color: #fafafa;
				}
				span {
					display: inline-block;
					vertical-align: middle;
					&:nth-child(1) {
						width: 120px;
						font-weight: 500;
					}
					&:nth-child(2) {
						width: 160px;
						overflow: hidden;
						white-space: nowrap;
						text-overflow: ellipsis;
					}
				}
			}
		}
	}
}
</style>
